import {getLocationById, getLocationByLngLat} from "@/http/services/http-services-route";
import {getCenter} from "ol/extent";
import {transform} from "ol/proj";
import {convertToDMS} from "@/helpers/lat-lon-helper";
import {addHtmlBySelector, getBySelector, removeElementBySelector} from "@/helpers/element-helper";
import {unblockUi} from "@/modules/elements-blockui";
import {getCesiumScene, isCesiumEnabled} from "@/modules/cesium/cesium";

import {getLatLonProjectionName, getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {getBookmarkPresentationsByID} from "@/helpers/ol/ol-layer-helper";


export function setGeometryLocation(olFeature, selector, presentationName = undefined, featureID = undefined, querySelectorChild = '.card') {

    const projection = getViewProjectionName()
    const olGeometry = olFeature.getGeometry()

    let center = getCenter(olGeometry.getExtent())

    getLocationByLngLat(center[0], center[1]).then((result) => {
        if(selector === 'bookmark-right-mouse-button') {
            getLocationById(result.adres.id).then(location => {

                window.selectedLocation = result
                window.selectedLocationAddress = location.response.docs[0]

                removeElementBySelector('bookmark-right-mouse-button')
                addHtmlBySelector('.info-menu-content', '<bookmark-right-mouse-button class="layer-info-block"></bookmark-right-mouse-button>')
                generateInfoOnLocation(selector, querySelectorChild, result, center, presentationName, featureID, projection)
            })
        } else {
            generateInfoOnLocation(selector, querySelectorChild, result, center, presentationName, featureID, projection)
        }
    })
}

export function getUrl(center, presentationName, featureID, withFilter = false) {

    let parameters = `&x=` + center[0] + `&y=` + center[1] + `&zoom=` + window.view.getZoom().toFixed(4);
    if(isCesiumEnabled()) {
        const camera = getCesiumScene().camera
        const position = camera.position
        parameters = '&mode=3D' + `&x=` + position.x + `&y=` + position.y + `&zoom=` + position.z + '&pitch=' + camera.pitch + '&roll=' + camera.roll + '&heading=' + camera.heading
    }

    let url = window.kaartViewerUrl + '/'
    if(window.location.origin === 'http://localhost:3000') {
        url = 'http://localhost:3000'
    }

    if(presentationName) {
        parameters += '&presentatie=' + presentationName
    }
    if(featureID) {
        parameters += '&waarde=' + featureID
    }

    const activeBookmarkPresentationIds = []
    document.querySelectorAll('layer-menu-overview .checkbox-group-item:checked').forEach(element => {
        if(element.dataset.presentationId) {
            activeBookmarkPresentationIds.push(element.value)
        }
    })

    const bookmarkPresentation =   window.settings.backgroundLayers.find(layer => layer.BookmarkPresentationID === parseInt((window.activeBookmarkPresentationID)))
    activeBookmarkPresentationIds.push(bookmarkPresentation.BookmarkPresentationID)

    const catalogusActive = getBySelector('layer-menu-switcher-button-active input')
    if(catalogusActive.checked) {
        parameters += '&catalogus=0'
    } else {
        parameters += '&catalogus=1'
    }

    if(withFilter) {
        parameters += '&filter=Filter met multiselect&filter_tekst=Dit is een tekst'
    }

    parameters += '&bookmarkpresentatieids=' + activeBookmarkPresentationIds.join() + '&v=5'

    if(window.ctrl && window.ctrl.layers && window.ctrl.layers.length > 0) {
        // Add the layers from the slider to the URL parameters
        parameters += '&slider='
        window.ctrl.layers.map(layer => {
            parameters += layer.layer.values_.name.replace('layer-', '') + ','
        })
        parameters = parameters.slice(0, -1);
    }

    return url + '?website=' + window.websiteName + parameters
}

export function generateInfoOnLocation(selector, querySelectorChild, result, center, presentationName, featureID, projection) {

    let latLon = transform(center, projection, getLatLonProjectionName())
    latLon = [Number(latLon[0].toFixed(6)), Number(latLon[1].toFixed(6))];
    const latLonDms = convertToDMS(latLon)

    const projectionText = '(' + getViewProjectionName() + ')'

    let centerText = center
    centerText = Math.round(centerText[0]) + ', ' + Math.round(centerText[1])

    try {
        const brc = new BroadcastChannel('cyclorama_return_channel');

        const message = {
            lat: center[1],
            lon: center[0]
        }

        brc.postMessage(message)
    } catch (e) {
        console.log(e)
    }

    const url = getUrl(center, presentationName, featureID)

    let innerHtml = `
        <div class="card ml-2 mr-2 mt-2">
            <div class="card-header p-2">
                <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse" data-bs-target="#collapse-info-location" aria-expanded="true"> 
                    Info op locatie
                    <div class="collapse-icon float-right"></div>
                </a>
            </div>
            <div id="collapse-info-location" class="collapse show pb-2 pt-1" style="">
                <div class="card-body pl-2 pr-2">
                        <div class="row">
                            <div class="col-5">XY ` + projectionText + `</div>
                            <div class="col-7">` + centerText + `</div>
                        </div>
                        <div class="row">
                            <div class="col-5">LatLon</div>
                            <div class="col-7">` + latLon.reverse().join(', ') + `</div>
                        </div>
                        <div class="row">
                            <div class="col-5">LatLon</div>
                            <div class="col-7">` + latLonDms + `</div>
                        </div>
                        <div class="row">
                            <div class="col-5">Adres</div>
                            <div class="col-7">` + result.adres.weergavenaam + `</div>
                        </div>`

    if(result.perceel.weergavenaam) {
        innerHtml += `
                        <div class="row">
                            <div class="col-5">Perceel</div>
                            <div class="col-7">` + result.perceel.weergavenaam + `</div>
                        </div>
                `
    }

    if(result.height) {
        innerHtml += `
                        <div class="row">
                            <div class="col-5">Hoogte (actuele AHN)</div>
                            <div class="col-7">` + result.height + ` meter</div>
                        </div>
                `
    }

    innerHtml += `
                 </div>
             </div>
        </div>
        <div class="card ml-2 mr-2 mt-2">
            <div class="card-header p-2">
                <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse" data-bs-target="#collapse-info-url" aria-expanded="true">
                    Url voor deze weergave
                    <div class="collapse-icon float-right"></div>
                </a>
            </div>
            <div id="collapse-info-url" class="collapse show pb-2 pt-1" style="">
                <div class="card-body pl-2 pr-2">
                   <a target="_blank" href="${url}">${url}</a>
                </div>
            </div>
        </div>`

    document.querySelector(selector).querySelector(querySelectorChild).insertAdjacentHTML('beforeend', innerHtml)

    unblockUi('.info-menu-content')
}
